<template>
  <div>
    <h4>Perguntas desta etapa:</h4>
    <div class="row mb-2" v-for="question in questions" :key="question.id">
      <div class="col-lg-12 col-xs-12">
        <div class="tab-pane">
          <div>
            <span
              class="color-primary d-inline-block"
              :class="{ pointer: question.video }"
              @click="show(question)"
              v-html="question.title"
              >{{ question.title }}</span
            >
            <font-awesome-icon
              icon="video"
              class="d-inline-block ml-1 color-primary"
              v-if="question.video"
            />
          </div>
          <transition name="fade">
            <div v-if="question.active">
              <video
                width="100%"
                class="mt-2"
                v-if="question.video"
                controls
                controlslist="nodownload"
              >
                <source :src="question.video" />
              </video>
            </div>
          </transition>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: ["questions_record"],
  data: () => ({
    questions: [],
  }),
  watch: {
    questions_record() {
      this.questions = [];
      for (let index in this.questions_record) {
        let current = this.questions_record[index];
        this.questions.push({
          title: current.title,
          description: current.description,
          time: current.time,
          number_retakers: current.number_retakers,
          video: current.video,
          video_id: current.video_id,
          job_id: current.job_id,
          selective_process_id: current.selective_process_id,
          active: false,
        });
      }
    },
  },
  methods: {
    show(question) {
      for (let i in this.questions) {
        if (this.questions[i] === question) continue;
        this.questions[i].active = false;
      }

      question.active = !question.active;
    },
  },
};
</script>